
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.605 6.729l-.771.77a.419.419 0 01-.588.005c-.045-.046-.091-.088-.137-.133-.43-.434-.817-.888-1.163-1.363a7.428 7.428 0 01-.816-1.42c-.196-.476-.296-.93-.296-1.363 0-.284.05-.554.15-.804.1-.255.258-.488.48-.696.266-.263.557-.392.866-.392.116 0 .233.025.337.075a.68.68 0 01.28.233l.966 1.363c.075.104.13.2.167.292a.659.659 0 01.058.254c0 .1-.029.2-.087.296a1.417 1.417 0 01-.234.295l-.316.33a.223.223 0 00-.067.166c0 .034.004.063.012.096.013.033.025.058.034.083.075.138.204.317.387.534.188.216.388.437.604.658.042.042.088.083.13.125.166.163.17.43.004.596zM9.154 8.137c0 .117-.02.238-.062.354-.013.034-.025.067-.042.1a1.878 1.878 0 01-.967.917c-.004 0-.008.004-.012.004-.246.1-.513.154-.8.154-.425 0-.88-.1-1.359-.304a7.319 7.319 0 01-1.433-.825c-.162-.12-.325-.242-.479-.37l1.362-1.363c.117.087.221.154.309.2l.075.033a.288.288 0 00.104.017.23.23 0 00.17-.071l.318-.313c.104-.104.204-.183.3-.233a.555.555 0 01.295-.087c.08 0 .163.016.255.054.091.037.187.091.291.162l1.38.98a.632.632 0 01.229.266.855.855 0 01.066.325z","fill":"#838883"}})])
          )
        }
      }
    